<template>
  <div>
    <div class="bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white">
      <div class="flex justify-between">
        <div class="flex justify-between flex-col">
          <h2 class="font-semibold leading-tight truncate text-single-line break-all text-2xl mt-2">{{ form.firstName.value ? form.firstName.value : 'New Customer' }}</h2>
          <p class="text-sm font-semibold tracking-wide mt-4" v-if="form.points">{{ form.points.toLocaleString() }} Points</p>
        </div>

        <div class="flex flex-col items-end">
            <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
          <div class="flex justify-end">
            <button v-if="can_edit_customer_details_in_admin" @click.prevent="update()" class="text-sm font-medium tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-2">
              <span>SAVE</span>
            </button>
            <button v-if="can_edit_customer_details_in_admin" @click.prevent="remove(item)" class="text-sm font-medium tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-red hover:bg-theme-darkgreen hover:text-white">
              <span>DELETE</span>
            </button>
          </div>
        </div>

      </div>
    </div>
    <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.firstName.error_type)">
            <label class="text-xs mb-1">First Name</label>
            <input v-model="form.firstName.value" @keyup="validateFields(['firstName'])" placeholder="First Name" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            <p class="field-error label-text mt-1" v-if="form.firstName.error_message" v-text="form.firstName.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.lastName.error_type)">
            <label class="text-xs mb-1">Last Name</label>
            <input v-model="form.lastName.value" @keyup="validateFields(['lastName'])" placeholder="Last Name" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            <p class="field-error label-text mt-1" v-if="form.lastName.error_message" v-text="form.lastName.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.email.error_type)">
            <label class="text-xs mb-1">Email</label>
            <div class="relative">
              <input v-model="form.email.value" @keyup="validateFields(['email'])" @input="alphaNumericEmail" placeholder="Email" 
                :class="'placeholder-theme-878686 block rounded bg-gray-black w-full text-sm text-theme-white' + (item.status == 'active' ? ' border-theme-orange pr-[80px]' : ' border-none')" type="text">
              <span class="text-xs font-semibold absolute right-1 top-1 pt-2 px-1 bg-gray-black h-8" :class="item.emailVerificationStatus?'text-theme-green':'text-theme-orange'">{{item.emailVerificationStatus?'verified':'unverified'}}</span>
            </div>
            <p class="field-error label-text mt-1" v-if="form.email.error_message" v-text="form.email.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.phone.error_type)">
            <label class="text-xs mb-1">Phone Number</label>
            <div class="relative">
              <input v-model.number="form.phone.value" :onkeypress="preventNonNumbers" @keyup="validateFields(['phone'])" placeholder="Phone Number" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="number">
               <span class="text-xs font-semibold absolute right-1 top-1 pt-2 px-1 bg-gray-black h-8" :class="item.phoneVerificationStatus?'text-theme-green':'text-theme-orange'">{{item.phoneVerificationStatus?'verified':'unverified'}}</span>
            </div>
            <p class="field-error label-text mt-1" v-if="form.phone.error_message" v-text="form.phone.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper'">
            <label class="text-xs mb-1">Birthday</label>
            
            <div class=" bg-gray-black rounded w-full flex items-center">
              
              <span class="ml-2 mr-2">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white" />
                </svg>
              </span>
              <Datepicker :inputFormat="'yyyy-MM-dd'" :startingViewDate="new Date(subtract18yr())" :upperLimit="new Date(subtract18yr())" v-model="form.dob" placeholder="Select a Date" class="text-sm focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full" /> 
            </div>

            <!-- <p class="text-xs mt-1 text-theme-orange">Date must be 18 year before</p> -->

          </div>
        </div>
        <div class="w-full xl:w-1/2">
          <div class="flex flex-row  items-center input-wrapper mb-3 mt-3 mr-2">
            <label class="text-xs mb-1 mt-2 mr-2">Casl Opt-In</label>
              <label class="flex items-center cursor-pointer xl:mt-2">
              <input type="checkbox" disabled :value="item.marketing" class="hidden peer">
              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (item.marketing ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
              <span class="ml-2 text-white text-sm font-medium uppercase w-[30px]" :class="item.marketing ? 'text-theme-green' : 'text-[#F53333]'">{{item.marketing ? 'On' : 'Off'}}</span>
            </label>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div class="input-wrapper ">
            <label class="text-xs mb-1">Total Spent</label>
            <div class="relative">
              <input disabled v-model="form.totalOrderValue" placeholder="Total Spent" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            </div>
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div class="input-wrapper">
            <label class="text-xs mb-1">Member Since</label>
            <div class="relative">
              <input disabled :value="formatDate(form.memberSince)" placeholder="Date" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            </div>
          </div>
        </div>
      </div>

      <div v-if="item.loyaltyUserId">
        <div class="bg-theme-borderblack h-1 w-full my-4"></div>
        <div class="w-full mb-4">
          <p class="text-xl font-semibold text-theme-878686">Point Adjustment</p>
        </div>

        <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
          
            <div class="w-full xl:w-1/2">
              <div :class="'input-wrapper'">
                <label class="text-xs mb-1">Point Amount</label>
                <div class="block border-none rounded bg-gray-black w-full text-sm text-theme-white px-3 py-2">{{ form.points?form.points:0 }}</div>
              </div>
            </div>

            <div class="w-full xl:w-1/2">
                <div class="flex gap-3 xl:flex-row flex-col justify-center mb-4">
                  <div class="w-full xl:w-1/2">
                    <button :disabled="!pointAdjustment.points.value || !can_edit_customer_details_in_admin" @click.prevent="adjustPoints()" class="disabled:cursor-default cursor-pointer mt-6 rounded-md bg-theme-green py-[6px] px-3 disabled:bg-theme-grey hover:bg-theme-darkgreen hover:text-white w-full">
                      CONFIRM
                    </button>
                  </div>
                  <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (pointAdjustment.points.error_type)">
                      <label class="text-xs mb-1">Point Adjustment</label>
                      <div class="block rounded bg-gray-black w-full relative">
                        <input :onkeypress="preventNonNumbers" @keyup="validateAdjustmentFormFields(['points'])" placeholder="Point Total" v-model.number="pointAdjustment.points.value"  class="placeholder-theme-878686 block border-none rounded bg-gray-black text-sm text-theme-white w-full pr-[60px]" type="number" />
                        <label class="flex items-center cursor-pointer absolute right-1 top-2">
                          <input type="checkbox" v-model="pointAdjustment.isAdditionalPoint" class="hidden peer">
                          <div :class="'relative toggle-bg label-inside-switch border-2  h-6 w-11 rounded-full ' + (pointAdjustment.isAdditionalPoint ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green')">
                            <span :class="'text-white ' + (pointAdjustment.isAdditionalPoint ? 'left-[3px] top-[1px] relative' : 'left-[21px] top-[1px] relative')"><mdicon v-if="pointAdjustment.isAdditionalPoint" size="16" name="plus" /> <mdicon v-if="!pointAdjustment.isAdditionalPoint" size="16" name="minus" /></span>
                          </div>
                        </label>
                      </div>
                      <p class="field-error label-text mt-1" v-if="pointAdjustment.points.error_message" v-text="pointAdjustment.points.error_message"></p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { defineComponent, ref} from "vue"
  import {mapGetters,mapActions,mapMutations} from "vuex";
  import { useSnackbar} from "vue3-snackbar";
  import Datepicker from 'vue3-datepicker'
  import Helpers from '@/helpers';
  import LoyaltyPointsAdjustmentApis from '@/controllers/LoyaltyPointsAdjustmentApis';
  import LoyaltyCustomerApis from '@/controllers/LoyaltyCustomerApis';
  import UserCustomerApis from '@/controllers/UserCustomerApis';
  import moment from 'moment';
  import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";


  export default defineComponent({
    name: "MembershipCustomerUpdate",
    components: {
      Datepicker,
      ReturnConfirmModal
    },
    props: {
      clearComponent: {
        type: Function,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
    },
    setup() {
      const snackbar = useSnackbar();
      const pointAdjustment = ref({
          points: {
            value: '',
            error_type: '',
            error_message: '',
            validations: ['required'],
          },
          isAdditionalPoint: true,
      });
      const form = ref({
        firstName: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        lastName: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        email: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'email'],
        },
        phone: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['mustbe:10'],
        },
        dob: '',
        points: 0,
        totalOrderValue: null,
        memberSince: null
      })
      const deleteObj = ref({
        modal: false,
        obj: {},
      });

      return {
        snackbar,
        form,
        pointAdjustment,
        deleteObj
      };
    },

    computed: {
      ...mapGetters({
        vg_locationSelected: "location/selected",
        vg_business: 'auth/activeBusiness',
      }),
      can_edit_customer_details_in_admin() {
        return Helpers.getMyPermission('can_edit_customer_details_in_admin')
      },
    },

    watch: {
      'item'() {
        this.assignValues();
      },
    },
    async mounted() {
      this.assignValues();
    },

    methods: {
      formatDate(dateVal){
        if(!dateVal) return
        return moment(dateVal).format('YYYY-MM-DD')
      },
      subtract18yr() { 
        return moment().subtract('18', 'years').format('YYYY-MM-DD')
      },
      async assignValues() {
        let data = await Helpers.assignFormValues(this.form, this.item);
        this.form = data
        this.form.firstName.value = this.item.firstName
        this.form.lastName.value = this.item.lastName
        this.form.memberSince = this.item.memberSince ? moment(this.item.memberSince).format('YYYY-MM-DD') : this.item.createdAt ? moment(this.item.createdAt).format('YYYY-MM-DD') : '';
        this.form.email.value = this.item.email
        this.form.dob = this.item.dob ? moment(this.item.dob).toDate() : '';
        this.form.phone.value = this.item.phone
        this.form.totalOrderValue = this.item.totalOrderValue
      },

      /**
       * Validation captures
       */
      async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.form, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
      },

      /**
       * Validate adjustent
       */
      async validateAdjustmentFormFields(fields) {
        let res = await Helpers.validateFormFields(this.pointAdjustment, fields);
        // capture the fields
        this.pointAdjustment = res.data;
        return res.error ? false : true;
      },

      /**
       * Update
       */
      async update() {
        // validate business field
        let validate = await this.validateFields(['firstName', 'lastName', 'phone', 'email']);
        if (!validate) {
          return;
        }
        let data = Helpers.getFormKeyValue(this.form);
        data.dob = this.form.dob ? moment(this.form.dob).format('YYYY-MM-DD') : null;
        data.phone = data.phone?data.phone.toString():null;
        data.businessSlug = this.vg_business.slug;
        data.locationSlug = this.vg_locationSelected.slug
        this.va_spinner(true);
        let res = await UserCustomerApis.update(this.item.id, data);  
        if(res.status == 200){
          // this.emitter.emit("update-loyalty-user", res.data);
            this.emitter.emit("refresh-loyalty-user-list", true);
          this.clearComponent()
        }
        this.va_spinner(false);
        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
      },
      
      /**
       * Adjust points
       */
      async adjustPoints() {
        let validate = await this.validateAdjustmentFormFields(['points']);
        // prevent removing points greater than available
        if(!this.pointAdjustment.isAdditionalPoint && this.pointAdjustment.points.value>this.form.points){
          validate = false
          this.pointAdjustment.points.error_type = 'error'
          this.pointAdjustment.points.error_message = 'Must be less than or equal to '+(this.form.points?this.form.points:0)
        }
        if (!validate) {
          return;
        }
        this.va_spinner(true);
        let res = await LoyaltyPointsAdjustmentApis.adjustPoint(this.item.loyaltyUserId, {
          points: this.pointAdjustment.isAdditionalPoint ?  this.pointAdjustment.points.value : -Math.abs(this.pointAdjustment.points.value),
          notes: "Points updated."
        })
        await this.fetchUserDetailsAndAssign();
        this.va_spinner(false);
        if(res.status == 201){
          this.pointAdjustment = await Helpers.resetFormValue(this.pointAdjustment);
        }
        this.snackbar.add({
          type: 'info',
          text: res.status == 201 ? (res.data.message ? res.data.message : res.data.msg) : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
      },

      /**
       * Fetch user details on success update // need for point object
       */
      async fetchUserDetailsAndAssign() {
        let res = await LoyaltyCustomerApis.getUserById(this.item.loyaltyUserId);
        if(res.status  == 200) {
          this.form.points = res.data.points;
          this.emitter.emit("refresh-loyalty-user-list", true);
          // this.emitter.emit("update-loyalty-user", res.data);
          // this.form = await Helpers.assignFormValues(this.form, res.data);
        }
      },
      
      /**
       * Do not allow to add +,-,e
       */
      preventNonNumbers(e) {
        var ASCIICode = (e.which) ? e.which : e.keyCode
        if (ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101) {
          return false;
        }
        return true;
      },

      alphaNumericEmail(){
          let x = this.form.email.value.replace(/[^a-z_\-0-9@\.]/gi, '')
          this.form.email.value = x
      },

       /**
       * Open delete confirm modal
       */
      openDeleteConfirmModal() {
        // this.deleteObj = {
        //   modal: true,
        //   obj: this.item,
        // };
      },

      /**
       * Close delete confirm modal
       */
      closeDeleteModal() {
        this.deleteObj = {
          modal: false,
          obj: {},
        };
      },

      /**
       * Delete  
       */
      remove(item){
        this.confirm('Are you sure to delete this?').then(async () => {
          this.va_spinner(true);
          let res = await UserCustomerApis.remove(item.id);
          this.va_spinner(false);
            this.snackbar.add({
            type: 'info',
            text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
            duration: 3000,
          })
          if(res.status == 200 ) {
            this.clearComponent();
            this.emitter.emit("refresh-loyalty-user-list", true);
          }
        })
      },

      ...mapActions({
        va_spinner: 'spinner/setSpinner',
      })
    },
  });
</script>